const Maintenance = () => {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				backgroundColor: '#fbd207',
				margin: 0,
			}}
		>
			<div style={{ textAlign: 'center' }}>
				<h1>Neural Network is under maintenance.</h1>
				<p>We will be back soon.</p>
			</div>
		</div>
	);
};

export default Maintenance;
